<template>
  <div>
    <div class="grid grid-cols-4 gap-2">
      <div class="font-bold text-xl">Order Detail</div>
      <div class="col-span-3 text-right">
        <base-button-success-small @click="goToDelivery()" class="m-1"
          >View Delivery</base-button-success-small
        >
        <base-button-primary-small @click="resend()" class="m-1"
          >Resend Order</base-button-primary-small
        >

        <base-button-primary-small @click="zip()" class="m-1"
          >Create Zip File</base-button-primary-small
        >

        <base-button-white-small @click="changeEmail()" class="m-1"
          >Change Email</base-button-white-small
        >

        <base-button-white-small @click="changeNote()" class="m-1"
          >Note</base-button-white-small
        >
        <base-button-white-small @click="back()" class="m-1"
          >Back</base-button-white-small
        >
      </div>
      <div class="col-span-4 my-5"><hr /></div>

      <div>
        <span class="label"> Outfitter </span>
      </div>
      <div class="break-all">
        {{ order.outfitter.name }}
      </div>
      <div>
        <span class="label"> Order ID </span>
      </div>
      <div class="break-all">
        {{ order.id }}
      </div>
      <div>
        <span class="label"> Date </span>
      </div>
      <div class="break-all">
        {{ order.display_date }}
      </div>
      <div>
        <span class="label"> Time </span>
      </div>
      <div class="break-all">
        {{ order.display_time }}
      </div>
      <div>
        <span class="label"> 24hr Order </span>
      </div>
      <div class="break-all">
        {{ order.isTwentyFourHour ? "Yes" : "No" }}
      </div>
      <div>
        <span class="label"> External Order </span>
      </div>
      <div class="break-all">
        {{ order.isExternal ? "Yes" : "No" }}
      </div>
      <div>
        <span class="label"> Counter Order </span>
      </div>
      <div class="break-all">
        {{ order.isCounterCheckout ? "Yes" : "No" }}
      </div>
      <div>
        <span class="label">Display Group</span>
      </div>
      <div class="break-all">
        {{ displayGroupName }}
      </div>
      <div>
        <span class="label"> Name </span>
      </div>
      <div class="break-all">
        {{ order.name }}
      </div>
      <div>
        <span class="label">Email </span>
      </div>
      <div class="break-all">
        {{ order.email }}
      </div>
      <div>
        <span class="label"> Discount Code </span>
      </div>
      <div class="break-all">
        {{ order.discount ? order.discount.name : "None" }}
      </div>
      <div>
        <span class="label">Commission-24</span>
      </div>
      <div class="break-all">${{ (order.commission_24 / 100).toFixed(2) }}</div>
      <div>
        <span class="label"> Commission </span>
      </div>
      <div class="break-all">${{ (order.commission / 100).toFixed(2) }}</div>
      <div>
        <span class="label"> Zip File </span>
      </div>
      <div v-if="order.zip_file">
        <a :href="getZipLink()">Get Zip</a>
      </div>
      <div v-else>None</div>
    </div>

    <div v-if="order.notes" class="bg-gray-400 w-full h-24 my-4 p-2">
      <b>Notes:</b>
      {{ order.notes }}
    </div>

    <div class="grid grid-cols-4 mt-5 p-2 bg-green-50">
      <div class="col-start-2">
        <span class="label"> Base Price </span>
      </div>
      <div>
        ${{
          (
            order.subtotal / 100 +
            order.discount_value / 100 +
            order.discount24 / 100
          ).toFixed(2)
        }}
      </div>

      <div class="col-start-2">
        <span class="label"> Discount 24hr </span>
      </div>
      <div>$({{ (order.discount24 / 100).toFixed(2) }})</div>
      <div class="col-start-2">
        <span class="label"> Discount </span>
      </div>
      <div>$({{ (order.discount_value / 100).toFixed(2) }})</div>

      <div class="col-start-2">
        <span class="label"> Subtotal </span>
      </div>
      <div>${{ (order.subtotal / 100).toFixed(2) }}</div>

      <div class="col-start-2">
        <span class="label"> Processing Fee </span>
      </div>
      <div>${{ (order.processingFee / 100).toFixed(2) }}</div>
      <div class="col-start-2">
        <span class="label"> River Fee </span>
      </div>
      <div>${{ (order.riverFee / 100).toFixed(2) }}</div>
      <div class="col-start-2">
        <span class="label"> River Section Fee </span>
      </div>
      <div>${{ (order.riverSectionFee / 100).toFixed(2) }}</div>

      <div class="col-start-2">
        <span class="label"> Tax </span>
      </div>
      <div>${{ (order.tax / 100).toFixed(2) }}</div>
      <div class="col-start-2">
        <span class="label"> Total </span>
      </div>
      <div>${{ (order.total / 100).toFixed(2) }}</div>
    </div>
    <change-order-email
      :showModal="showModal"
      :emailData="emailData"
      @saved="handleSaved"
      @close="showModal = false"
    ></change-order-email>
    <add-note
      :show-modal="noteModal"
      :new-data="noteData"
      @saved="handleNoteSaved"
      @close="noteModal = false"
    ></add-note>
  </div>
</template>

<script>
import BaseButtonPrimarySmall from "../ui/buttons/BaseButtonPrimarySmall";
import ChangeOrderEmail from "../common/ChangeOrderEmail";
import AddNote from "../common/AddNote";
import BaseButtonWhiteSmall from "../ui/buttons/BaseButtonWhiteSmall";
import BaseButtonSuccessSmall from "../ui/buttons/BaseButtonSuccessSmall";
export default {
  name: "OrderDetail",
  components: {
    BaseButtonSuccessSmall,
    BaseButtonWhiteSmall,
    AddNote,
    ChangeOrderEmail,
    BaseButtonPrimarySmall,
  },
  props: {},
  data() {
    return {
      showModal: false,
      emailData: {
        id: null,
        email: null,
      },
      noteData: {
        id: null,
        note: "",
      },
      noteModal: false,
      loading: null,
    };
  },
  methods: {
    getZipLink() {
      return (
        "https://api.whitewaterphotography.com/deliveries/" +
        this.order.zip_file.name
      );
    },
    zip() {
      this.$store.dispatch("order/zip", this.$route.params.orderId);
      this.$notify({
        title: "Order",
        message:
          "Zip file creation can take a few minutes. A link to the file will be emailed to the purchaser when it is available",
        type: "success",
        duration: 5000,
      });
    },
    back() {
      this.$router.go(-1);
    },
    resend() {
      if (confirm("Are you sure you want to re-email this order?")) {
        this.$notify({
          title: "Order",
          message: "Resending...",
          type: "success",
        });
        this.$store.dispatch("order/resend", this.order.id).then((resp) => {
          if (!resp.success) return;
          this.$notify({
            title: "Order",
            message: "This order has been resent",
            type: "success",
          });
        });
      }
    },
    handleSaved() {
      this.$store.dispatch("report/get_order", this.$route.params.orderId);
      this.emailData = {
        id: null,
        email: null,
      };
      this.showModal = false;
    },
    handleNoteSaved() {
      this.$store.dispatch("report/get_order", this.$route.params.orderId);
      this.noteData = {
        id: null,
        note: "",
      };
      this.noteModal = false;
    },
    changeEmail() {
      this.emailData.id = this.order.id;
      this.emailData.email = this.order.email;
      this.showModal = true;
    },
    changeNote() {
      this.noteData.id = this.order.id;
      this.noteData.note = this.order.notes;
      this.noteModal = true;
    },
    goToDelivery() {
      window.open(this.getOrderLink(), "_blank");
    },
    getOrderLink() {
      return (
        process.env.VUE_APP_FRONTEND_URL +
        "/deliver/" +
        this.order.outfitter.slug +
        "/order/" +
        this.order.hash
      );
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    order: function () {
      return this.$store.getters["report/getOrder"];
    },
    displayGroupName: function () {
      let displayGroupName = null;
      if (this.order && this.order.order_items) {
        this.order.order_items.forEach((item) => {
          if (item.display_group) {
            displayGroupName = item.display_group.name;
          }
        });
      }
      return displayGroupName;
    },
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.$store
      .dispatch("report/get_order", this.$route.params.orderId)
      .then(() => {
        this.loading.close();
      });
  },
};
</script>

<style scoped>
.label {
  @apply font-bold text-lg mr-2;
}
</style>
